import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { FitnessBenefitListItemExtension } from './fitness-benefit-list-item.extension';
import { FitnessBenefitMetadataExtension } from './fitness-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('fitness')
    .add(BenefitMetadataExtensionInterface, new FitnessBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new FitnessBenefitListItemExtension())
    .build(),
);
